/* eslint-disable max-len */
import { useMutation } from '@apollo/client';
import React, { useState } from 'react';
import AdminModal from '../../../components/AdminModal';
import TextInput from '../../../components/input';
import SelectSearch from '../../../components/SelectSearch';
import useForm from '../../../customHooks/useForm';
import useToast from '../../../customHooks/useToast';
import { CREATE_KAABO_PARTNER } from '../../../graphql/admin_mutations';
import InfoIconNew from '../../../svgs/InfoIconNew';
import Styles from './GeneratePartnerTrackingCode.module.scss';

interface IGeneratePartnerTrackingCodeModal{
  closeModal:any;
  refetch:any;
}
const GeneratePartnerTrackingCodeModal = ({ closeModal, refetch }:IGeneratePartnerTrackingCodeModal) => {
  const Toast = useToast();
  const [showSuccessModalState, setShowSuccessModalState] = useState(false);
  const [createKaaboPartnerRequest, { loading: createKaaboPartnerLoading }] = useMutation<
  { createKaaboPartner: any },
  any
>(CREATE_KAABO_PARTNER);
  const [country, setCountry] = useState('');
  const {
    formValues, handleChange, resetForm,
  } = useForm(
    {
      partnerName: '',
      email: '',
    },
    {},
    Toast,
  );

  const handleSubmit = async () => {
    if (!formValues?.partnerName || !formValues?.email || !country) {
      return Toast.error('All fields are required');
    }

    const variables = {
      partnerName: formValues?.partnerName,
      email: formValues?.email,
      country,
    };

    if (!createKaaboPartnerLoading) {
      try {
        const res = await createKaaboPartnerRequest({ variables });

        if (
          res?.data?.createKaaboPartner
          && res?.data?.createKaaboPartner?.status === 200
        ) {
          refetch?.();
          resetForm();
          setShowSuccessModalState(true);
        } else {
          setShowSuccessModalState(false);
          Toast.error(res?.data?.createKaaboPartner?.message || 'Operation Failed');
        }
      } catch (e: any) {
        if (e && e.graphQLErrors && e.graphQLErrors.length > 0) {
          Toast.error(e.graphQLErrors[0].message);
        } else {
          Toast.error('Something went wrong');
        }
      }
    }
  };

  return (
    <div className={Styles.wrapper}>
      <AdminModal
        headText={showSuccessModalState ? 'Code Generated Successfully!' : 'Generate Tracking Code'}
        subText={showSuccessModalState ? (
          <div className={Styles.wrapper__subtitle}>
            You have successfully generated a tracking code for
            {' '}
            <span>{`${formValues?.partnerName}`}</span>
            , the partner will be informed and it will be reflected on their dashboard.
          </div>
        ) : 'Kindly provide the details below to generate tracking code for a partner.'}
        actionBtnName="generate code"
        handleModalAction={handleSubmit}
        topIcon={<InfoIconNew />}
        isShow
        isSuccess={showSuccessModalState}
        isActionBtnDisabled={createKaaboPartnerLoading}
        onClickAway={() => {}}
        onClose={closeModal}
        isLoading={createKaaboPartnerLoading}
      >
        {
          !showSuccessModalState && (
          <div>
            <div>
              <TextInput
                name="partnerName"
                value={formValues?.partnerName}
                label="Partner company name"
                isRequired
                customOnChange={handleChange}
                backgroundColor="rgba(255, 255, 255, 1)"
              />
            </div>
            <div>
              <TextInput
                name="email"
                value={formValues?.email}
                label="Email address of Partner"
                isRequired
                customOnChange={handleChange}
                backgroundColor="rgba(255, 255, 255, 1)"
              />
            </div>
            <div>
              <SelectSearch
                label=""
                options={[
                  { label: 'Canada', value: 'Canada' },
                  { label: 'USA', value: 'usa' },
                ]}
                placeholder="Select Country"
                name="Select Country"
                value={country}
                classes={false}
                isRequired
                hideLabel
                onChange={(e) => setCountry(e?.target?.value)}
                disabled={false}
              />
            </div>
          </div>
          )
        }

      </AdminModal>
    </div>

  );
};

export default GeneratePartnerTrackingCodeModal;
